import { render, staticRenderFns } from "./DashboardGraphs.vue?vue&type=template&id=4b3396a4&scoped=true"
import script from "./DashboardGraphs.vue?vue&type=script&lang=js"
export * from "./DashboardGraphs.vue?vue&type=script&lang=js"
import style0 from "./DashboardGraphs.vue?vue&type=style&index=0&id=4b3396a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3396a4",
  null
  
)

export default component.exports